import * as headerNavCSS from '../components/Header/Navigation/Navigation.scss';

export const $ = <T extends Element>(query: string, context = document) => context.querySelector<T>(query);

export const $$ = <T extends Element>(query: string, context: ParentNode = document) => Array.from(context.querySelectorAll<T>(query));

export const getNavigationMenus = () => $$<HTMLAnchorElement>('[data-hook=wix-header-main-menu] [data-toggle=collapse]');

export const getMainMenuWrapper = () => $<HTMLElement>('[data-hook=wix-header-main-menu]')!;

export const getHeader = () => $<HTMLElement>('[data-wix-header=hf2020]');

export const getDesktopLoginLink = () => $<HTMLAnchorElement>(`[data-hook=login].${headerNavCSS.desktopOnly}`)!;

export const getAccountMenuButton = () => $<HTMLAnchorElement>('[data-wix-header=hf2020] [data-hook=wix-header-account-name-button]')!;
